/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetUsersResponse } from '../entities/GetUsersResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { getUsersModelSchema } from './getUsersModelSchema'
import { z } from 'zod'

export const getUsersResponseSchema = z.object({
  users: z.array(z.lazy(() => getUsersModelSchema)).optional(),
}) as unknown as ToZod<GetUsersResponse>